import { FC, useMemo } from "react";
import RoundedPlus from "../../UI/Icons/RoundedPlus";
import CustomButton from "../../UI/Buttons/CustomButton";
import { useNavigate } from "react-router";
import { AUTH_ROUTE } from "../../../pages/App/routes";
import {
  useAppDispatch as useDispatch,
  useAppSelector as useSelector,
} from "../../../store";
import Roles from "../../../models/roles";
import { resetCentrePicAction } from "../../../store/superadmin/slice";

/**
 * CentresAndUsers Props Interface
 * @interface CentresAndUsersProps
 */
interface CentresAndUsersProps {
  /**
   * Specifies the type of entity to create, either "centres" or "users".
   */
  create: string;
  /**
   * Optional callback function to open the user creation modal.
   * This function is called when the "Create" button is clicked and `create` is set to "users".
   * It allows for custom handling of user creation, such as displaying a modal or navigating to a user creation form.
   */
  handleCreateUser?: () => void;
}

const CentresAndUsers: FC<CentresAndUsersProps> = ({
  create,
  handleCreateUser,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const totalActiveCentresCount = useSelector(
    (state) => state.superadmin.totalActiveCentresCount
  );
  const totalCentresCount = totalActiveCentresCount;

  const totalCentreAdminCount = useSelector(
    (state) => state.superadmin.totalCentreAdminCount
  );
  const totalCentreUsersCount = useSelector(
    (state) => state.superadmin.totalCentreUserCount
  );
  const centresUserCount = totalCentreAdminCount + totalCentreUsersCount;

  const user = useSelector((state) => state.auth.user);

  const isSuperAdmin = useMemo(
    () => user?.role.name === Roles.SUPER_ADMIN,
    [user]
  );

  const handleCentresList = () => {
    navigate(AUTH_ROUTE.ADMIN_CENTERS);
  };

  const handleUsersList = () => {
    navigate(AUTH_ROUTE.ADMIN_CENTERS_USERS);
  };

  const handleCreate = async () => {
    sessionStorage.clear();
    if (create === "centres") {
      localStorage.setItem("centre_id", "");
      await dispatch(resetCentrePicAction());
      navigate(AUTH_ROUTE.ADMIN_CREATE_CENTRE);
    } else if (create === "users") {
      if (handleCreateUser) {
        handleCreateUser();
      }
    }
  };

  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex gap-10 justify-content-between">
          <div className="d-flex gap-10">
            <div
              className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px py-5px cursor-pointer ${
                create === "centres"
                  ? "bg-black text-white"
                  : "bg-off-white text-black"
              }`}
              onClick={handleCentresList}
            >
              <span className="fw-700">
                {totalCentresCount === 0 ? "" : totalCentresCount}
              </span>{" "}
              Centres
            </div>
            <div
              className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px py-5px cursor-pointer ${
                create === "users"
                  ? "bg-black text-white"
                  : "bg-off-white text-black"
              }`}
              onClick={handleUsersList}
            >
              <span className="fw-700">
                {centresUserCount === 0 ? "" : centresUserCount}
              </span>{" "}
              Users
            </div>
          </div>
          <div className="d-none d-md-block">
            <CustomButton
              variant={"primary"}
              type="button"
              className="btn-theme bg-white text-black h-36px"
              onClick={handleCreate}
            >
              <RoundedPlus fill={"#000000"} /> Create
            </CustomButton>
          </div>
        </div>
        <div className="bg-black w-100 h-5px"></div>

        <div className="d-block d-md-none text-center">
          <CustomButton
            variant={"primary"}
            type="button"
            className="btn-theme bg-white text-black h-36px"
            onClick={handleCreate}
          >
            <RoundedPlus fill={"#000000"} /> Create
          </CustomButton>
        </div>
        {/* <div className="bg-black w-100 h-5px"></div> */}
      </div>
    </>
  );
};

export default CentresAndUsers;
